import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { configValue } from '../../utils'
import { CONFIG_KEYS } from '../../constants'

export default function FileAlertModal({ modal, toggle }) {
  console.log('AlertModal rendered')

  const maxFileSize = configValue(CONFIG_KEYS.maxFileSize.key) ? configValue(CONFIG_KEYS.maxFileSize.key) : CONFIG_KEYS.maxFileSize.defaultValue

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>File Too Large</ModalHeader>
      <ModalBody>{`The size of the selected file exceeds the maximum file size of ${maxFileSize}MB.`}</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Ok</Button>
      </ModalFooter>
    </Modal>
  )
}
